import MultiSelectRow from 'edge/platform/widgets/multiselect/components/multiselectrow/index';
import MultiSelect from 'edge/platform/widgets/multiselect/components/multiselect/index';

export default angular.module('edge.platform.widgets.multiselect', []).component('gwMultiSelectRow', MultiSelectRow).component('gwMultiSelect', MultiSelect);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/multiselect/module.js
// module id = 1137
// module chunks = 0